import React, {useEffect, useState} from 'react'
import { Box, Button, Typography, Modal } from '@mui/material';
import Swal from 'sweetalert2';
import { encryptFormData} from '../../utils/crypt-module/encrypt';
import withReactContent from 'sweetalert2-react-content';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import { useAuth } from '../../custom-hooks/useAuth';
import { connect } from 'react-redux';
import Loader from '../Loader';
import { useTranslation } from 'react-i18next';


const { participantUpdateAction } = dashboardActions;


function EditMediaInfo ({
    handleClose, 
    open, 
    style, 
    participant, 
    participantUpdateState, 
    participantUpdateDispatchAction, 
    handleUpdateInfo}) {
 
const ReactSwal = withReactContent(Swal);

 //handle input validations
 const editFormInputObject = {
    media_allowed: '',
 }

 const { t } = useTranslation();


 const { getLogin } = useAuth();
 const loginStorage = JSON.parse(getLogin());

 const [updatedParticipantInput, setUpdatedParticipantInput] = useState(editFormInputObject);
 const [errors, setErrors] = useState({});


 const required_fields = [ "media_allowed" ];
 
 useEffect(() => {
    setUpdatedParticipantInput(participant)
 }, [participant]);


 const validateInputs = () => {
    let newErrors = {};

    if (updatedParticipantInput.vaccination_fsme === 'yes' && !updatedParticipantInput.vaccination_fsme_year) {
        newErrors.vaccination_fsme_year = 'This field is required';
      }
    
    if (updatedParticipantInput.vaccination_tetanus === 'yes' && !updatedParticipantInput.vaccination_tetanus_year) {
        newErrors.vaccination_tetanus_year = 'This field is required';
    }

    required_fields.forEach(field => {
      if (!updatedParticipantInput[field]) {
        newErrors[field] = 'This field is required';
      }
    });

    if (updatedParticipantInput.email && !/\S+@\S+\.\S+/.test(updatedParticipantInput.email)) {
      newErrors.email = 'Email is invalid';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const handleInputChange = (e) => {
    const {name , value}  = e.target;

    setUpdatedParticipantInput({
        ...updatedParticipantInput,
        [name]: value
    });
 }

 const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateInputs()) {
        return;
    } else {
        if(updatedParticipantInput){
           
            const params = {
                publicKey: process.env.REACT_APP_PUB_KEY_1,
                formData:updatedParticipantInput
            }
            //encrypt form data 
           encryptFormData(params)
            .then((encryptedData) => {
                const form_data = {
                    id: updatedParticipantInput.id,
                    token: loginStorage && loginStorage.loginData.data.token,
                    ...encryptedData
                }
                participantUpdateDispatchAction(form_data);
            })
        }
    }
  };

  useEffect(() => {

    if(participantUpdateState.status === "participant_update_success"){
        handleClose();
        ReactSwal.fire({
            title: `${t('swal-messages.Success')}!`,
            text: `${t('swal-messages.Participant')} ${t('swal-messages.Updated')} ${t('swal-messages.Successfully')}!`,
            icon: 'success',
        })
    }
    
    if(participantUpdateState.status === "participant_update_failed") {
        handleClose();
        ReactSwal.fire({
            title: `${t('swal-messages.Error')}!`,
            text: `${t('swal-messages.There was a problem')} ${t('swal-messages.Updating')} ${t('swal-messages.The participant')}!`,
            icon: 'error',
            confirmButtonText: 'OK'
        })
    }

    const updateInfo = {
        updateStatus: participantUpdateState.status,
        updateData: participantUpdateState.participantUpdateData
    }
    handleUpdateInfo(updateInfo);

  }, [participantUpdateState.status])


  return (
    <>
        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='-z-50 relative'
        >
            <Box sx={style}>
            {participantUpdateState.status === "participant_update_start" && <Loader componentType="edit-participant-modal" />}
            <form  action="" onSubmit={handleSubmit}>
                <div className="w-full h-[38vh] rounded-lg bg-white p-10 pt-0 overflow-auto relative">
                    <div className="flex justify-between items-center w-auto bg-white h-20 sticky top-0"> 
                        <Typography 
                        variant="h4" 
                        sx={{ 
                            color: '#2F4858', 
                            fontWeight: '500',
                            fontSize: '28px' 
                        }}
                        >
                          {participant.first_name} {participant.last_name}
                        </Typography>
                        <div className="flex gap-5 items-center">
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: '#FDB315',
                                    px: 3,
                                    py: '0.59rem',
                                    borderRadius: '999px',
                                    color: 'white',
                                    fontWeight: 600,
                                    fontSize: '12px',
                                    '&:hover': {
                                    backgroundColor: '#FDB315',
                                    color: 'white',
                                    }
                                }}
                            >
                                {t('modals.Update')}
                            </Button>
                            <div onClick={handleClose} className='cursor-pointer bg-[#EFEFEF] hover:bg-[#eeeeff] w-10 h-10 flex items-center justify-center rounded-full'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M18 6l-12 12" />
                                    <path d="M6 6l12 12" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5">
                        <div className="border rounded-lg p-5">
                            <h1 className="text-[16px] text-tertiary font-medium">{t('modals.Edit')} {t('modals.Media Information')}</h1>
                            <div className="flex gap-5 mt-4">
                                <div className="flex flex-col w-full">
                                    <label className="font-medium text-[14px]">{t('modals.Media Allowed')} </label>
                                    <select name = "media_allowed" value={updatedParticipantInput.media_allowed} onChange={handleInputChange} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] ">
                                        <option value="">- SELECT-</option>
                                        <option value="yes" selected = {updatedParticipantInput.media_allowed === 'yes'}>Yes</option>
                                        <option value="no"  selected={updatedParticipantInput.media_allowed === 'no'}>No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            </Box>
        </Modal>
    </>
  )
}

const mapStateToProps = state => ({
    participantUpdateState: state.dashboardState
})

const mapDispatchToProps = dispatch => ({
    participantUpdateDispatchAction: (params) => dispatch(participantUpdateAction(params)),
})


export default connect(mapStateToProps, mapDispatchToProps)(EditMediaInfo)